"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Balance_vue_1 = __importDefault(require("../../pages/balance/Balance.vue"));
const Invoices_vue_1 = __importDefault(require("../../pages/invoices/Invoices.vue"));
const PackingSlips_vue_1 = __importDefault(require("../../pages/packingSlips/PackingSlips.vue"));
const Orders_vue_1 = __importDefault(require("../../pages/orders/Orders.vue"));
const OpenOrders_vue_1 = __importDefault(require("../../pages/openOrders/OpenOrders.vue"));
const Coupons_vue_1 = __importDefault(require("../../pages/coupons/Coupons.vue"));
const GuaranteeProductReturnList_vue_1 = __importDefault(require("../../pages/guaranteeProductReturnList/GuaranteeProductReturnList.vue"));
const CustomerProductReturnList_vue_1 = __importDefault(require("../../pages/customerProductReturnList/CustomerProductReturnList.vue"));
const CarcassReturnList_vue_1 = __importDefault(require("../../pages/carcassReturnList/CarcassReturnList.vue"));
const TargetNumbers_vue_1 = __importDefault(require("../../pages/targetNumbers/TargetNumbers.vue"));
exports.default = [
    {
        name: 'queries_balance',
        path: '/queries/balance',
        component: Balance_vue_1.default,
        meta: { requiresAuth: true, title: 'Balance' }
    },
    {
        name: 'queries_invoices',
        path: '/queries/invoices',
        component: Invoices_vue_1.default,
        meta: { requiresAuth: true, title: 'Invoices' }
    },
    {
        name: 'queries_packing_slips',
        path: '/queries/packing-slips',
        component: PackingSlips_vue_1.default,
        meta: { requiresAuth: true, title: 'Packing Slips' }
    },
    {
        name: 'queries_orders',
        path: '/queries/orders',
        component: Orders_vue_1.default,
        meta: { requiresAuth: true, title: 'Orders' }
    },
    {
        name: 'queries_open_orders',
        path: '/queries/open-orders',
        component: OpenOrders_vue_1.default,
        meta: { requiresAuth: true, title: 'Open Orders' }
    },
    {
        name: 'queries_coupons',
        path: '/queries/coupons',
        component: Coupons_vue_1.default,
        meta: { requiresAuth: true, title: 'Coupons' }
    },
    {
        name: 'queries_guarantee_product_return_list',
        path: '/queries/guarantee-product-return-list',
        component: GuaranteeProductReturnList_vue_1.default,
        meta: { requiresAuth: true, title: 'Guarantee Product Return List' }
    },
    {
        name: 'queries_customer_product_return_list',
        path: '/queries/customer-product-return-list',
        component: CustomerProductReturnList_vue_1.default,
        meta: { requiresAuth: true, title: 'Customer Product Return List' }
    },
    {
        name: 'queries_carcass_return_list',
        path: '/queries/carcass-return-list',
        component: CarcassReturnList_vue_1.default,
        meta: { requiresAuth: true, title: 'Carcass Return List' }
    },
    {
        name: 'queries_target_numbers',
        path: '/queries/target-numbers',
        component: TargetNumbers_vue_1.default,
        meta: { requiresAuth: true, title: 'Target Numbers' }
    },
    {
        name: 'queries_target_numbers_api',
        path: '/api/get-target-numbers',
        redirect: '',
        meta: { requiresAuth: true }
    },
];
